import { clientId } from "./constants";
import "./propertyRenderers";
import "./appLinks";

export const assetManagementRoutes = [
  {
    path: "/asset-management",
    name: "assetManagement",
    component: () =>
      import("@shared/assetManagement/views/AssetTypeSelection.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "assets",
          route: { name: "assetManagement" },
        },
      ],
    },
  },
  {
    path: "/asset-management/:template",
    name: "assetManagementList",
    props: true,
    component: () =>
      import("@shared/assetManagement/views/AssetManagementListView.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "assets",
          route: { name: "assetManagement" },
        },
      ],
    },
  },
  {
    path: "/asset-management/:template/edit/:id?",
    name: "assetManagementDetail",
    props: true,
    component: () =>
      import("@shared/assetManagement/views/AssetManagementDetailView.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "assets",
          route: { name: "assetManagement" },
        },
      ],
    },
  },
  {
    path: "/asset-reports",
    name: "assetReportsOverview",
    component: () =>
      import("@shared/assetManagement/views/AssetReportsOverview.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "reports",
          route: { name: "assetReportsOverview" },
        },
      ],
    },
  },
  {
    path: "/asset-reports/assets",
    name: "assetReports",
    component: () => import("@shared/assetManagement/views/ReportAssets.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "reports",
          route: { name: "assetReportsOverview" },
        },
        {
          label: "assets",
          route: { name: "assetReports" },
        },
      ],
    },
  },
  {
    path: "/asset-reports/changelogs",
    name: "assetReportChangelogs",
    component: () =>
      import("@shared/assetManagement/views/ReportAssetsChangelog.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "reports",
          route: { name: "assetReportsOverview" },
        },
        {
          label: "changelog",
          route: { name: "assetReportChangelogs" },
        },
      ],
    },
  },
  {
    path: "/asset-reports/custom/:groupId",
    name: "assetCustomReport",
    props: true,
    component: () =>
      import("@shared/assetManagement/views/AssetCustomReport.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "reports",
          route: { name: "assetReportsOverview" },
        },
      ],
    },
  },
  {
    path: "/asset-access",
    name: "assetAccess",
    component: () =>
      import("@shared/assetManagement/views/AssetManagementAccess.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "accessRights",
          route: { name: "assetAccess" },
        },
      ],
    },
  },
  {
    path: "/asset-dashboards",
    name: "assetDashboardList",
    component: () =>
      import("@shared/assetManagement/views/AssetDashboardList.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "dashboard",
          route: { name: "assetDashboardList" },
        },
      ],
    },
  },
  {
    path: "/asset-dashboards/:dashboardId",
    name: "assetDashboardDetail",
    component: () =>
      import("@shared/assetManagement/views/AssetDashboardDetail.vue"),
    props: true,
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "dashboard",
          route: { name: "assetDashboardList" },
        },
        {
          label: "detail",
          route: { name: "assetDashboardDetail" },
        },
      ],
    },
  },
  {
    path: "/asset-management/tickets/:id",
    name: "assetManagementTicketDetail",
    props: true,
    component: () => import("./views/AssetManagementTicketDetail.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/asset-management/ticket-history/:id",
    name: "assetManagementTicketHistory",
    props: true,
    component: () => import("./views/AssetManagementTicketHistory.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/asset-management/my-tickets",
    name: "assetManagementMyTickets",
    props: true,
    component: () => import("./views/AssetManagementMyTickets.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/asset-management/ticket-search",
    name: "assetManagementTicketSearch",
    component: () => import("./views/AssetManagementTicketSearch.vue"),
    meta: {
      appClientId: clientId,
    },
  },
];
